<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon">close</mat-icon>
</button>

    <h1 mat-dialog-title align="center">Espacio de Trabajo</h1>
    <mat-progress-bar *ngIf="categoriesAdd.length == 0 && layersAdd.length == 0 && formsAdd.length == 0 && !formsAsignados" mode="indeterminate"></mat-progress-bar>
        <div mat-dialog-content>
          <p *ngIf="formsAsignados">No se han asignado formularios al usuario</p>
          <mat-accordion>
            <mat-expansion-panel *ngFor="let category of categoriesAdd">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{category.categoria_capa_nombre}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-accordion>
            <ng-container *ngFor="let layer of layersAdd">
              <mat-expansion-panel *ngIf="layer.categoria_capa_id==category.categoria_capa_id">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{layer.capa_nombre}}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-list>
                  <ng-container *ngFor="let form of formsAdd">
                    <mat-list-item *ngIf="form.capa_id==layer.capa_id">
                      <mat-radio-button checked="false"  color="primary" 
                    (click)="changeActuallyCategoryLayer(category.categoria_capa_nombre,layer.capa_nombre, form.formulario_nombre, form.formulario_Id)"
                          >
                          {{form.formulario_nombre}}</mat-radio-button>
                    </mat-list-item>
                  </ng-container>
                </mat-list>
                    
              </mat-expansion-panel>
            </ng-container>
          </mat-accordion>
          </mat-expansion-panel>
          </mat-accordion>
          
        </div>



